import { trackIndiaFxTestAssigned } from 'actions/tracker/tracker';
import { FF_INDIA_FX_TEST } from 'constants/features';
import { IN_COUNTRY_CODE } from 'constants/index';
import { CHECKOUT_PLATFORM } from 'constants/ui';
import { useExperimentFlag } from 'hooks/useExperiments/useExperimentFlag';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  getRecipientCountryCode,
  getRecipientId,
  isEducationClient,
} from 'selectors/entities/recipient/recipient';
import { getCurrentCountryCode } from 'selectors/ui/ui';
import { useDispatch } from 'store/configureStore';

export const useIndiaFxTestExperiment = () => {
  const dispatch = useDispatch();
  const countryFrom = useSelector(getCurrentCountryCode);
  const recipientId = useSelector(getRecipientId);
  const recipientCountry = useSelector(getRecipientCountryCode);
  const isEducation = useSelector(isEducationClient);

  const isIndianPayer = countryFrom === IN_COUNTRY_CODE;
  const isUsEdu = !!isEducation && recipientCountry === 'US';
  const hasRequiredContext = isIndianPayer && isUsEdu && !!recipientId;

  const { value: isInTestGroup, isFetched } = useExperimentFlag(
    {
      flagName: FF_INDIA_FX_TEST,
      userContext: {
        country_from: countryFrom ?? '',
        portal_code: recipientId,
        platform: CHECKOUT_PLATFORM,
      },
    },
    { enabled: hasRequiredContext },
  );

  useEffect(() => {
    if (isFetched && hasRequiredContext) {
      dispatch(trackIndiaFxTestAssigned(isInTestGroup));
    }
  }, [isFetched, isInTestGroup, hasRequiredContext, dispatch]);

  return { hideNonFxOptions: isFetched && isInTestGroup };
};
